module.exports = "/_next/static/images/MakeInformedDecisions-272e338071d24d7a28b374cd686a412a.webp";